module.exports = __webpack_public_path__ + "static/media/06_avatar_animal.ef9843f7.png";